import React from "react";
import clsx from "clsx";
import { Box } from '@curves/ui-base';
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const MeasurementClickableCard = ({ className, name, value = 0, unit, icon, onClick }) => {
	return (
		<Box className={clsx("measurement-clickable-card", className)} onClick={onClick}>
			<Box className="measurement-clickable-card__icon-right">
				<ChevronRightIcon />
			</Box>
			{icon != null && (
				<Box className="measurement-clickable-card__icon" aria-hidden>
					{typeof icon === "function" ? React.createElement(icon, {}) : icon}
				</Box>
			)}
			<Box className="measurement-clickable-card__title">{name}</Box>
			<Box className="measurement-clickable-card__value measurement-clickable-card__value--normal">
				{value}
				{unit && <Box className="measurement-clickable-card__value-unit">{unit}</Box>}
			</Box>
		</Box>
	);
};

export default MeasurementClickableCard;
